module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/schemes/schemes.component.css
// module id = ./src/app/schemes/schemes.component.css
// module chunks = main